<template>
  <div class="membership-info">
    <div>
      <slot></slot>
    </div>
    <div>
      <router-link class="btn btn-sm btn-mol btn-membership-details" to="/membership">
        <img class="button-icon" :src="`${$imagePathBase}logo-white.svg`"/> Learn About Membership
      </router-link>
    </div>
  </div>
</template>


<script>
export default {
  name: "MembershipPitchCard"
}
</script>


<style scoped>

.membership-info {

  z-index: 4;
  box-shadow: 0px 0px 20px 1px lightgrey;

  margin-left: auto;
  margin-right: auto;

  padding: 1em;
  text-align: center;
  font-weight: 500;
  font-size: larger;
  color: var(--mol-color-gold);

  border-style: double;
  border-width: 5px;
  border-color: var(--mol-color-gold);
  border-radius: 10px;

  background-color: var(--mol-color-gold-background);

  max-width: min(600px, calc(100vw - var(--bs-gutter-x)));
}

.btn-membership-details {
  position: relative;
  font-weight: bold;

  margin-top: 0.75em;

  img {
    vertical-align: text-bottom;
    height: 1.5em;
  }
}

</style>